const strings = {
    appName: 'Gregor Management',

    tableLoadingTip: 'Carregando...',
};

export default strings;
